import {Pipe, PipeTransform} from '@angular/core';
import {ActionModel} from '../models/action.model';

@Pipe({
    name: 'filterActions'
})
export class FilterActionsPipe implements PipeTransform {
    transform(actions: ActionModel[], text: string): ActionModel[] {

        if (!text || text.length <= 0) {
            return actions;
        }
        return actions.filter(action => {
            let custName = '';
            let contName = '';
            if (action.cust_id) {
                custName = action.customerDTO.name;
            }
            if (action.actee_map_id) {
                contName = action.contactDTO.name;
            }
            return custName.toLowerCase().includes(text.toLowerCase())
                || action.comment.toLowerCase().includes(text.toLowerCase())
                || contName.toLowerCase().includes(text.toLowerCase());
        });
    }

}
